<style scoped>
    .selectize-spinner {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0%;
        left: 0%;
    }
</style>
<template>
        <div style="position:relative;height:100%" class="form-group" v-bind:class="{ 'has-error' : !drugController || drugController.hasError }" >

            <div >
                <selectize v-model="selection"
                           class="form-control"
                           :load="loadResults"
                           labelField="searchText"
                           valueField="searchText"
                           searchField="searchText"
                           maxOptions="25"
                           openOnFocus="true"
                           placeholder="Search drug here" />
            </div>
            <div class="selectize-spinner form-group" style="height:100%; z-index:12" v-show="isLoading">
                <span class="pull-right" style="padding-right:35px;  padding-top:10px;">
                    <i class="fa fa-refresh fa-spin fa-1x fa-fw text-success"></i>
                </span>
            </div>
            <div class="selectize-spinner form-group" style="height:100%; z-index:11" v-show="(!drugController || drugController.hasError) && !isLoading">
                <span class="pull-right" style="padding-right:35px;  padding-top:10px;">
                    <i class="fa fa-exclamation-triangle" v-bind:class="{ 'text-danger' : !drugController || drugController.hasError }"></i>
                </span>
            </div>
        </div>
</template>
<script>
    import selectize from "./../../corecontrols/selectize/selectize.scp.html"
    import { DrugDto } from './../../../dto/DrugDto'
    import Dal from './../../../scripts/dataaccess'
    import DrugSearchSelectorController from './DrugSearchSelectorController'

    export default {
        model: {
            prop  : 'drugController',
            event : 'input'
        },
        props: ['drugController'],
        data: function () {
            return {
                isLoading: false,
                controller: {},
                selection: new DrugDto()
            }
        },
        mounted: function () {
            console.log("Controller of drugselector is", this.$props.drugController)
        },
        watch: {
            'selection': function (val) {
                console.log("Drug selection changed to", val)
                console.log(this.$props.drugController)
                
                this.drugController.value = val;
                //this.$emit('input', val);
            }
        },
        methods: {
            loadResults: function (query, callback) {
                if (!query.length) return callback();
                var dal = new Dal();
                this.isLoading = true;
                var that = this;
                setTimeout(() => {
                    dal.SearchDrug(query).then(data => {
                        callback(data);
                        this.isLoading = false;
                    });
                }, 1000);
            }
        },
        components: {
            selectize
        }
    }
</script>


// WEBPACK FOOTER //
// DrugSearchSelector.scp.html?41e4a27d